import { questionById, questions } from "../config/questions";
import type { AssessmentAnswers, QuestionId } from "../types/friction-finder";

export function normalizePlainText(value: string, max: number): string {
  return value.normalize("NFC").replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, "").trim().slice(0, max);
}

export function validateQuestionAnswer(questionId: QuestionId, answers: AssessmentAnswers): string | null {
  const question = questionById[questionId];
  const selected = answers[questionId];
  if (!Array.isArray(selected) || selected.length < question.min) return question.validation.empty;
  if (selected.length > question.max) return question.validation.over ?? question.validation.empty;
  if (new Set(selected).size !== selected.length) return "Choose each answer only once.";
  if (selected.some((id) => !question.options.some((option) => option.id === id))) return "Choose a valid answer.";
  if (question.type === "single" && selected.length !== 1) return question.validation.empty;
  if (questionId === "affected_groups" && selected.includes("everyone") && selected.length !== 1) return question.validation.over ?? question.validation.empty;
  if (questionId === "primary_friction" && selected.includes("other_friction")) {
    const length = normalizePlainText(answers.customFriction ?? "", 160).length;
    if (length < 10 || length > 160) return question.validation.custom ?? question.validation.empty;
  }
  if (questionId === "desired_outcomes" && selected.includes("other_outcome")) {
    const length = normalizePlainText(answers.customOutcome ?? "", 120).length;
    if (length < 5 || length > 120) return question.validation.custom ?? question.validation.empty;
  }
  return null;
}

export function validateAllAnswers(answers: AssessmentAnswers): Record<QuestionId, string> | null {
  const errors = {} as Record<QuestionId, string>;
  for (const question of questions) {
    const error = validateQuestionAnswer(question.id, answers);
    if (error) errors[question.id] = error;
  }
  return Object.keys(errors).length ? errors : null;
}
